// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"15b61312","322":"90ce6ba4","375":"4447ac84","470":"2935825f","670":"02ef08b3"}[chunkId] + ".chunk.css";
};